import React from 'react';
import {Input} from 'components/vitrade-forms/common';
import LaddaButton, {XL, EXPAND_LEFT} from 'react-ladda';
import {toastr} from 'react-redux-toastr';
import {Orders} from 'api';
import moment from 'moment';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {cleanShoppingCart} from 'actions';
import {getPrice} from 'lib/convert';

class OrderForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isSubmit: false,
      name: '',
      phone: '',
      email: '',
      address: '',
      coupon: ''
    };
    this.props.validators['orderForm'] = [];
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  validateSubmitForm() {
    let isValid = true;
    this.props.validators['orderForm'].map(validator => {
      if (isValid) {
        isValid = validator.validate();
      } else {
        validator.validate();
      }
    });
    if (!isValid) {
      toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
      return false;
    }
    return isValid;
  }

  onSubmit(e) {
    e.preventDefault();
    if (this.validateSubmitForm()) {
      const {name, phone, email, address, coupon} = this.state;
      const data = {
        customerName: name,
        customerPhone: phone,
        customerEmail: email,
        customerAddress: address,
        coupon,
        shipDate: moment(),
        amount: this.props.amount,
        businessIds: this.props.businessIds
      };
      this.setState({isSubmit: true});
      Orders.actions.createOrder.request({}, {data}).then((response) => {
        const orders = this.props.products.map(product => ({
          orderId: response.data.id,
          productId: product.id,
          quantity: product.count,
          price: getPrice(product.promotionalPrice || product.price, null) || 0
        }));
        Orders.actions.addItems.request({}, {data: orders}).then(() => {
          this.setState({isSubmit: false});
          this.props.dispatch(cleanShoppingCart());
          toastr.success('Thành công!', 'Bạn đã đặt hàng thành công.');
          this.props.history.push('/user/order-history');
        });
      }).catch((error) => {
        toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
        this.setState({isSubmit: false});
      });
    }
  }

  getUserInfo(e) {
    e.preventDefault()
    let {fullname, phone, email, address} = this.props.auth.user;
    this.setState({
      name: fullname, phone, email, address
    })
  }

  render() {
    const {isSubmit, name, phone, email, address, coupon} = this.state;
    return (
      <form className="shopping-cart-form-order form-vt" name="orderForm" method="POST" onSubmit={this.onSubmit} noValidate>
        <h3 className="order-heading">Thông tin đặt hàng&nbsp;&nbsp;&nbsp;{this.props.auth && this.props.auth.isAuthenticated &&(<button className='btn btn-vt-submit mt10 mb10' onClick={this.getUserInfo.bind(this)}>Sử dụng thông tin cá nhân</button>)}</h3>
        <div className="shopping-cart-form">
          <Input type="text" placeholder="Họ và tên..."
            iconClassName="fa fa-user-o"
            name="name"
            value={name}
            required={true}
            onChange={this.onChange}
            bindValidator={this} channel="orderForm"
            errorMessage="Tên không được để trống"/>
          <Input type="text" placeholder="Số điện thoại..."
            iconClassName="fa fa-mobile"
            name="phone"
            value={phone}
            onChange={this.onChange}
            bindValidator={this} channel="orderForm"/>
          <Input type="text" placeholder="Email..."
            iconClassName="fa fa-at"
            name="email"
            value={email}
            onChange={this.onChange}
            bindValidator={this} channel="orderForm"/>
          <Input type="text" placeholder="Địa chỉ..."
            iconClassName="fa fa-map-marker"
            name="address"
            value={address}
            onChange={this.onChange}
            bindValidator={this} channel="orderForm"/>
          <Input type="text" placeholder="Mã giảm giá..."
            iconClassName="fa fa-gift"
            name="coupon"
            value={coupon}
            onChange={this.onChange}
            bindValidator={this} channel="orderForm"/>
        </div>
        <div className="shopping-cart-buttons">
          <button type="button" disabled={isSubmit} onClick={this.props.showForm} className="btn-vt-default m-g-r">Huỷ</button>
          <LaddaButton className="btn-vt-submit" type="submit" data-size={XL} data-style={EXPAND_LEFT} loading={isSubmit}>Đặt hàng</LaddaButton>
        </div>
      </form>
    );
  }
}

OrderForm.defaultProps = {
  validators: {}
};

const bindStateToProps = state => {
  return {auth: state.auth}
}

export default withRouter(connect(bindStateToProps)(OrderForm));



// WEBPACK FOOTER //
// ./components/users/sub-view/shopping-cart/OrderForm.jsx